// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { IFormPriceBook } from '~/utils/interface/priceBook';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      name: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      serviceIds: yup.array().optional(),
      materialIds: yup.array().optional(),
    })
    .required();
};

export const defaultValuesForm: IFormPriceBook = {
  name: EMPTY_STRING,
  serviceIds: [],
  materialIds: [],
};
